'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _footer = require('../actions/footer');

var FooterActions = _interopRequireWildcard(_footer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case FooterActions.INIT_FOOTER:
            return action.footerInfo;

        case FooterActions.SET_LEFT_FOOTER:
            return Object.assign({}, state, { left: action.leftFooter });

        case FooterActions.SET_CENTER_FOOTER:
            return Object.assign({}, state, { center: action.centerFooter });

        case FooterActions.SET_RIGHT_FOOTER:
            return Object.assign({}, state, { right: action.rightFooter });

        case FooterActions.UPDATE_CLASS_FOOTER:
            {
                return _extends({}, state, {
                    classes: action.classFooter.classes,
                    styles: action.classFooter.styles
                });
            }
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/footer.js
// module id = 777
// module chunks = 0